<template>
  <div>
    <!-- El ícono del Asistente de IA se pinta junto al título del campo, no dentro del textarea. -->
    <div v-if="label != ''" class="eq-ask row align-items-center form-text-area-label-row">
      <strong class="col-12 my-4 ml-3 d-flex align-items-center">
        <span>{{ label }}:</span>
        <slot v-if="showAiIcon" name="ai-icon" />
      </strong>
    </div>
    <div class="form-group mb-5 ml-3 w-100">
      <CustomTextArea
        :id="id"
        :class="{ 'was-Invalidated': error }"
        :rows="rows"
        :disabled="disabled"
        :placeholder="placeholder"
        :required="required"
        :minlength="minlength"
        :maxlength="maxlength"
        :value="value"
        :error="errorDesc"
        :custom-error-msg="customErrorMsg"
        :highlighted="highlighted"
        @input="updateValue"
      />
    </div>
  </div>
</template>

<style scoped>
span.invalid:not(input) {
  color: #e85c5c;
}
.form-control-icon-normal {
  position: absolute;
  top: 9px;
  right: 10px;
  font-size: 19px;
  color: rgba(63, 91, 96, 0.3);
}
.form-control-icon-invalid {
  color: #e85c5c;
  position: absolute;
  top: 9px;
  right: 10px;
  font-size: 19px;
}
.input-label {
  height: 19px;
  text-align: left;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
  line-height: 19px;
}
</style>

<script>
import CustomTextArea from '@/components/common/CustomTextArea.vue';

export default {
  meta: {
    description: 'Componente para entrada de texto multilínea con icono.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    id: {
      type: String,
      default: 'customTextArea',
      meta: {
        description: 'Id del Componente FormTextArea',
        example: 'idFormTextArea',
      },
    },
    label: {
      type: String,
      default: '',
      meta: {
        description: 'Control para mostrar texto',
        example: 'Texto requerido',
      },
    },
    placeholder: {
      type: String,
      default: '',
      meta: {
        description: 'Texto de referencia en el textarea',
        example: 'Texto requerido',
      },
    },
    value: {
      type: String,
      default: '',
      meta: {
        description: 'Parámetro de entrada en el textarea',
        example: 'Texto requerido',
      },
    },
    required: {
      type: String,
      default: function() {
        return 'required';
      },
      meta: {
        description: 'Estado requerido',
        example: 'Texto requerido',
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      meta: {
        description: 'Estado Disabled',
        example: 'true',
      },
    },
    minlength: {
      type: Number,
      default: 0,
      required: false,
      meta: {
        description: 'Logitud mínima requerida',
        example: 'Texto requerido',
      },
    },
    maxlength: {
      type: Number,
      default: 0,
      required: false,
      meta: {
        description: 'Logitud máxima requerida',
        example: 'Texto requerido',
      },
    },
    rows: {
      type: Number,
      default: 5,
      meta: {
        description: 'Especifica el número de líneas de texto visibles',
        example: '40',
      },
    },
    error: {
      type: String,
      default: '',
      meta: {
        description: 'Estado Error',
        example: 'Texto requerido',
      },
    },
    // Bind error CustomTextArea.
    errorDesc: {
      type: String,
      default: '',
      meta: {
        description: 'Error encontrado',
        example: 'Texto requerido',
      },
    },
    icon: {
      type: String,
      default: '',
      meta: {
        description: 'Propiedad para el icono',
        example: 'fas fa-times',
      },
    },
    customErrorMsg: {
      type: String,
      default: function() {
        return this.errorDesc;
      },
      meta: {
        description: 'Mensaje de error encontrado',
        example: 'Texto requerido',
      },
    },
    // US 156915 - activa/desactiva el ícono del Asistente Virtual en la esquina del campo.
    // Pensada para que la pantalla consumidora (ej. Tab3.vue del PEI) pase directamente su
    // propio parámetro de sistema (ej. 'EnableAiAssistantPei') en vez de tener que envolver
    // el slot #ai-icon en su propio v-if para lograr el mismo efecto.
    showAiIcon: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Muestra el ícono del Asistente Virtual en la esquina del campo',
        example: 'true',
      },
    },
    // US 156915 - reenviado directo a CustomTextArea (ver ese componente para el border +
    // fondo violeta real). Por defecto false -- el resto de las pantallas que no pasan esta
    // prop quedan igual.
    highlighted: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Resalta el textarea con border y fondo violeta (uso del Asistente de IA)',
        example: 'true',
      },
    },
  },
  methods: {
    updateValue: function(value) {
      this.$emit('input', value);
    },
  },
  computed: {},
  components: {
    CustomTextArea,
  },
};
</script>
